import toast from "@/services/toast.js";

export default {
    validate(measurement, show_toast = true, concept = false, classification_method = "IB22") {
        // measurement type should be set
        if (!measurement.measurement_type_id) {
            show_toast ? toast.error("Selecteer een type meting") : null;
            return false;
        }

        // Name should always be set
        if (!measurement.name) {
            show_toast ? toast.error("Vul een naam in") : null;
            return false;
        }

        // IB22 classification should be set
        if (
            !concept &&
            // !measurement.completed &&
            measurement.rules.result == "incorrect" &&
            classification_method == "IB22" &&
            (!measurement.classification.danger_aspect_id ||
                !measurement.classification.error_indication_id ||
                !measurement.classification.error_classification_id ||
                !measurement.classification.repair_period_id)
        ) {
            show_toast
                ? toast.error(
                      "Meting kan niet worden afgerond omdat de classificatie niet is ingevuld."
                  )
                : null;
            return false;
        }

        // Remark should be set
        if (
            !concept &&
            measurement.completed == false &&
            measurement.rules.result == "inconclusive" &&
            measurement.remark < 10
        ) {
            show_toast ? toast.error("Vul een toelichting in van minimaal 10 tekens") : null;
            return false;
        }

        // Measurement type id should be set
        if (!measurement.measurement_type_id && !concept) {
            show_toast ? toast.error("Selecteer een type meting") : null;
            return false;
        }

        // Measurement type id should be set
        if (!measurement.measurement_type_id && !concept) {
            show_toast ? toast.error("Selecteer een type meting") : null;
            return false;
        }

        return true;
    },
};
